<template>
  <div>
    <div class="font-weight-bold title">
      {{ $t('payment.download') }}
    </div>
    <hr>
    <div class="d-flex">
      <div class="mx-3">
        <div>
          <label>{{ $t('report.from') }}</label>
        </div>
        <BFormDatepicker
          v-model="from"
          hide-header
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          type="date"
          class="picker"
        >
          <template #nav-this-month>
            <div />
          </template>
        </BFormDatepicker>
      </div>
      <div class="mx-3">
        <div>
          <label>{{ $t('report.to') }} (włącznie)</label>
        </div>
        <BFormDatepicker
          v-model="to"
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          hide-header
          type="date"
          class="picker"
        >
          <template #nav-this-month>
            <div />
          </template>
        </BFormDatepicker>
      </div>
    </div>
    <hr>
    <div>
      <div class="font-weight-bold pb-2">
        Format:
      </div>

      <div class="mx-3">
        <BoxSelect
          :style="{ width: formatTypes.length * 150 + 'px' }"
          :fields="formatTypes"
          :selected="formatType"
          @update:selected="formatType = $event"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        class="btn btn-primary"
        :disabled="!from || !to || pendingExport"
        @click="requestExportPayments"
      >
        <i class="fas fa-download mr-2" />
        {{ $t('payment.download') }}
      </button>
    </div>
  </div>
</template>

<script>
import BoxSelect from '@/components/BoxSelect';
import { BFormDatepicker } from 'bootstrap-vue';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    from: moment().startOf('month').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    formatType: 'xlsx',
    pendingExport: false,
  }),
  components: {
    BFormDatepicker,
    BoxSelect,
  },
  computed: {
    ...mapGetters(['payeeId']),
    formatTypes() {
      return [
        {
          key: 'xlsx',
          icon: 'fas fa-file-excel',
          text: 'Excel',
          format: 'xlsx',
        },
        ...(this.payeeId === 'a0feeb9b-2f8c-4bc7-a4cb-886c9c7f2a3e'
        || this.payeeId === '61a5e4d1-5775-4843-9203-d3f3f8349d69' ? [{
            key: 'enrol',
            icon: 'fas fa-file-code',
            text: 'Enrol Json',
            format: 'json',
          }] : []),
      ];
    },
  },
  methods: {
    ...mapActions(['exportPayments']),
    requestExportPayments() {
      this.pendingExport = true;
      this.exportPayments({
        params: {
          query: {
            from: this.from,
            to: moment(this.to).add(1, 'day').format('YYYY-MM-DD'),
            format: this.formatType,
          },
        },
      })
        .then(({ data }) => {
          const format = this.formatTypes.find((x) => x.key === this.formatType)?.format;
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `${this.$t('menu.payments')}_${this.from}_${this.to}`;
          link.setAttribute('download', `${fileName}.${format}`);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.pendingExport = false;
        });
    },
  },
};
</script>

<style scoped>
.picker {
  width: 300px;
}

.title {
  font-size: 1.5rem;
}
</style>
